import Handlebars from '@sparta.global.vendors/handlebars';

/* eslint-disable valid-jsdoc */
// The module to be exported
/**
   * {{meta}}
   * @return {String} <meta name="description" content="Awesome Description Here">
   * @param {String} values for meta tags
   */
function meta(values) {
  /** ********* IMPORTANT! **********
     3/21/18 - zkt9zad C. Desrochers
     helpers-entity v1.0.0
       normalizeHTML function has been copied from utilities>helpers>helpers-entity.
     Until we can find a way for a helper function to be imported into helpers-meta we will
     maintain two copies of helpers-entity.  helpers-entity should be updated, then coped here...
     */
  function normalizeHTML(str1, str2, str3, str4, str5) {
    const str = str1 + (typeof str2 === 'string' ? str2 : '') + (typeof str3 === 'string' ? str3 : '') + (typeof str4 === 'string' ? str4 : '') + (typeof str5 === 'string' ? str5 : '');
    // noinspection NonAsciiCharacters
    const replaceChars = {
      '‘': '\'',
      '’': '\'',
      '“': '"',
      '”': '"'
    };
    // noinspection NonAsciiCharacters
    const encodedChars = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '©': '&copy;',
      '®': '&reg;',
      '™': '&trade;',
      Á: '&Aacute;',
      á: '&aacute;',
      É: '&Eacute;',
      é: '&eacute;',
      Í: '&Iacute;',
      í: '&iacute;',
      Ó: '&Oacute;',
      ó: '&oacute;',
      Ú: '&Uacute;',
      ú: '&uacute;',
      Ü: '&Uuml;',
      ü: '&uuml;',
      Ñ: '&Ntilde;',
      ñ: '&ntilde;',
      '¿': '&iquest;',
      '¡': '&iexcl;'
    };

    /**
       * @return {Boolean} true or false
       * @param {String} string that may be a URL
       */
    function isURL(string) {
      const regexp = new RegExp('^http(s?):', 'i'); // does the string begin with http: or https:?
      return regexp.test(string);
    }

    /**
       * @return {String} decoded
       * @param {String} string that may be a URL
       */
    function decodeStr(string) {
      // remove all entities and start from clean content
      let scopedString = string;
      Object.keys(replaceChars).forEach(k => {
        const regex = new RegExp(k, 'g');
        scopedString = scopedString.replace(regex, replaceChars[k]);
      });
      Object.keys(encodedChars).forEach(k => {
        const regex = new RegExp(encodedChars[k], 'g');
        scopedString = scopedString.replace(regex, k);
      });
      return scopedString;
    }

    /**
       * @return {String} encoded
       * @param {String} string that may be a URL
       */
    function encodeStr(string) {
      // replace all non-alphabetic characters with HTML entity
      let scopedString = string;
      Object.keys(encodedChars).forEach(k => {
        const regex = new RegExp(k, 'g');
        scopedString = scopedString.replace(regex, encodedChars[k]);
      });
      return scopedString;
    }
    if (str !== undefined) {
      let scopedString = str;
      scopedString = decodeStr(scopedString);
      if (isURL(scopedString)) {
        return scopedString; // if str is a URL then it should not be encoded
      }
      return encodeStr(scopedString); // convert all required characters to entities
    }
    return null;
  }

  /** ********* IMPORTANT! SEE NOTE ABOVE... ********** */

  const metaStr = [];
  let metaValue;
  let value;
  Object.keys(values).forEach(key => {
    metaValue = values[key];
    if (typeof metaValue === 'string') {
      value = metaValue;
    } else {
      value = metaValue.default;
    }
    value = normalizeHTML(value);
    switch (key) {
      case 'title':
        metaStr.push(`<title>${value}</title>`);
        break;
      case 'canonical':
        metaStr.push(`<link rel="canonical" href="${value}">`);
        break;
      case 'amphtml':
        metaStr.push(`<link rel="amphtml" href="${value}">`);
        break;
      case 'alternate':
        value = values[key];
        metaStr.push(`<link rel="alternate" href="${value.href}" hreflang="${value.hreflang}">`);
        break;
      case 'alternates':
        value = values[key];
        value.forEach(item => metaStr.push(`<link rel="alternate" href="${item.href}" hreflang="${item.hreflang}">`));
        break;
      case 'structuredData':
        // This data is handled by the semantic-markup-module
        // (should be renamed to structured-markup-module)
        break;
      case 'SI_TRADUC':
        // This data is only to be used for OET translation indicators
        // and should not be included in the meta tags
        break;
      case 'NO_TRADUC':
        // This data is only to be used for OET translation indicators
        // and should not be included in the meta tags
        break;
      default:
        // these are edge cases to handle a key with a value, that cannot be defined above
        if (value !== 'undefined') {
          let metaWritten = false;
          if (!metaWritten && key.substring(0, 2) === 'og') {
            metaStr.push(`<meta property="${key}" content="${value}">`);
            metaWritten = true;
          }
          if (!metaWritten && key.substring(0, 7) === 'twitter') {
            metaStr.push(`<meta name="${key}" content="${value}">`);
            metaWritten = true;
          }
          if (!metaWritten) {
            metaStr.push(`<meta name="${key}" content="${value}">`);
          }
        }
        break;
    }
  });
  return metaStr.join('\n');
}

/**
   * @method genericMeta
   * @param {Object} [tags={}] Object of arrays representing attributes of elements in HEAD.
   * @param {Object} [context={}] Object for contextual reference for tokenized values
   * @returns {NodeList} Handlebars.SafeString() of several generic-related meta elements
   * @description takes an Object of meta tags with attribute definitions like those shown
   *  below and returns relevant Handlebars Nodes; attribute values can use simple tokens
   *  like "%%site.params.cdn.hostname%%" which will be resolved against the context params
   *  attributes
   *
   *  Example:
   *
   *  "tags": {
   *    "meta": [
   *      {
   *        "http-equiv": "x-dns-prefetch-control",
   *        "content": "on"
   *      }
   *    ],
   *    "link": [
   *      {
   *        "rel": "dns-prefetch",
   *        "href": "https://bankofamerica.com/",
   *        "crossorigin": true
   *      },
   *      {
   *        "rel": "preconnect",
   *        "href": "%%site.params.cdn.hostname%%"
   *      }
   *    ]
   *  }
   *
   * Generates:
   *
   * <meta http-equiv="x-dns-prefect-control" content="on">
   * <link rel="dns-prefetch" href="https://bankofamerica.com/" crossorigin>
   * <link rel="preconnect" href="https://www.bac-assets.com/">
   */
function genericMeta(tags, context = {}) {
  // make sure we were provided an Object of tags
  if (tags && typeof tags === 'object') {
    // potential valid tags to generate
    const validTags = ['meta', 'link'];

    // initialize Array for storing generated meta tags
    const generatedTags = [];

    // RegEx to check for tokenized values
    const tokenRegEx = /^(?:%%)(.*)(?:%%)$/;

    // iterate through tag types
    Object.keys(tags).forEach(tagType => {
      if (validTags.indexOf(tagType) !== -1) {
        // get tags for this type and iterate through them
        tags[tagType].forEach(tag => {
          // initialize Array for storing relevant attributes for this tag
          const tagAttributes = [];

          // iterate through attributes
          // we use an Array.prototype.every() here because we want to make sure
          // that we can resolve any tokenized attribute values
          // if a value isn't resolved, we'll exit the Array.prototype.every()
          const attributesReady = Object.keys(tag).every(tagAttribute => {
            // if the attribute's value was set to true, we will make it a Boolean attribute
            if (tag[tagAttribute] === true) {
              tagAttributes.push(tagAttribute);

              // move to next iteration
              return true;
            }

            // test for a tokenized attribute value
            const testForToken = tokenRegEx.exec(tag[tagAttribute]);

            // if a token match was found
            if (testForToken) {
              // get the path from the token
              const tokenPath = testForToken[1].split('.');

              // for token resolution; default to context
              let currentPath = context;

              // iterate through parts of token path and check for existence
              // we use an Array.prototype.every() here because we want to make sure
              // that every key in the path resolves
              const resolvedPath = tokenPath.every(pathKey => {
                // if the currently resolved path has this property
                if (Object.prototype.hasOwnProperty.call(currentPath, pathKey)) {
                  // set the current path with the current key
                  currentPath = currentPath[pathKey];

                  // move to next iteration
                  return true;
                }

                // exit Array.prototype.every()
                return false;
              });

              // if we found our path and the current path resolves to a String
              if (resolvedPath && typeof currentPath === 'string') {
                // add the resolved token to our attributes Array
                tagAttributes.push(`${tagAttribute}="${currentPath}"`);

                // move to next iteration
                return true;
              }

              // exit Array.prototype.every()
              return false;
            }

            // add non-tokenized, non-null attribute string to our attribute array
            tagAttributes.push(`${tagAttribute}="${tag[tagAttribute]}"`);

            // move to next iteration
            return true;
          });

          // if all of our attributes were resolved properly
          if (attributesReady) {
            // add tag to our tags Array
            generatedTags.push(`<${tagType} ${tagAttributes.join(' ')}>`);
          }
        });
      }
    });

    // return generated Handlebars string for meta tags
    return new Handlebars.SafeString(generatedTags.join('\n'));
  }

  // don't do anything without tags
  return null;
}

/**
 * @class Helper
 * @description Class used to register our helper with Handlebars
 */

export { genericMeta, meta };
